import { render, staticRenderFns } from "./DokumentLogModal.vue?vue&type=template&id=3433aedf"
import script from "./DokumentLogModal.vue?vue&type=script&lang=js"
export * from "./DokumentLogModal.vue?vue&type=script&lang=js"
import style0 from "./DokumentLogModal.vue?vue&type=style&index=0&id=3433aedf&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports